const ImageSlider = ({ images }) => {
  const getTagStyle = (color) => {
    const styles = {
      green: "bg-green-500 text-white border-green-500",
      purple: "bg-purple-600 text-white border-purple-600",
      blue: "bg-blue-500 text-white border-blue-500",
      orange: "bg-orange-500 text-white border-orange-500",
    };
    return styles[color] || styles.green;
  };

  return (
    <div className="relative w-full overflow-hidden">
      <div
        className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide pl-4 pr-4"
        style={{
          WebkitOverflowScrolling: "touch",
          scrollBehavior: "smooth",
        }}
      >
        {images?.map((banner, index) => (
          <div
            key={index}
            onClick={() => banner.onClick?.() || banner.onBannerClick?.(banner)}
            className={`image-slider-card ${banner.bgColor} p-6 flex-shrink-0 snap-start mr-4 rounded-xl shadow-lg cursor-pointer hover:brightness-95 transition-all active:scale-[0.98]`}
            style={{
              width: "85vw",
              scrollSnapAlign: "start",
              marginRight: index === images.length - 1 ? "0" : "1rem",
            }}
          >
            <div className="mb-4">
              <span
                className={`inline-block px-4 py-1.5 rounded-full text-xs font-semibold tracking-wide ${getTagStyle(
                  banner.tagColor
                )}`}
              >
                {banner.tag}
              </span>
            </div>

            <div className="max-w-[250px]">
              <h2 className="text-3xl font-bold text-gray-900 mb-3 leading-tight">
                {banner.title}
              </h2>

              <p className="text-gray-600 mb-6 text-sm">{banner.subtitle}</p>

              {banner.buttonText && (
                <button className={`px-6 py-2 rounded-lg text-white text-sm font-bold shadow-md ${banner.buttonColor || 'bg-gray-900'}`}>
                  {banner.buttonText}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div >
  );
};

export default ImageSlider;
